import QueriesPlaceholder from './QueriesPlaceholder';

export default QueriesPlaceholder;
